import type { ReactNode } from 'react';
import styles from '@/styles/components/PageHeader/style.scss';

interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  /** Right-hand side: status chips, actions. */
  aside?: ReactNode;
}

export function PageHeader({ title, subtitle, aside }: PageHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.titles}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </div>
      {aside && <div className={styles.aside}>{aside}</div>}
    </header>
  );
}
